/* eslint-disable @typescript-eslint/explicit-function-return-type */
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
const createExtraScopePlugin = (...extra) => {
    const scopes = extra.map((scope) => `${scope.trim()} `);
    return (element) => {
        var _a;
        if (element.type !== 'rule') {
            return;
        }
        if (((_a = element.root) === null || _a === void 0 ? void 0 : _a.type) === '@keyframes') {
            return;
        }
        element.props = element.props
            .map((prop) => scopes.map((scope) => scope + prop))
            .reduce((scopesArray, scope) => scopesArray.concat(scope), []);
    };
};
export const cacheWithScope = (wrapperClassName) => {
    const prefix = `.${wrapperClassName} `;
    return createCache({
        stylisPlugins: [prefixer, createExtraScopePlugin(prefix)],
        key: 'css',
    });
};
